import { render, staticRenderFns } from "./SmMaterialDisplay.vue?vue&type=template&id=d946811a&scoped=true&"
import script from "./SmMaterialDisplay.vue?vue&type=script&lang=ts&"
export * from "./SmMaterialDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./SmMaterialDisplay.vue?vue&type=style&index=0&id=d946811a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d946811a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VIcon,VImg})
